export default __webpack_public_path__ + "static/media/tenor.3ddfb162.gif";